import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Picture from 'components/picture';
import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';

const DeliveryDisclaimerContainer = styled.div`
  text-align: center;
  margin-top: 1rem;
  font-size: 0.65rem;
`;

const DeliveryLogoContainer = styled.div`
  width: 10rem;
  margin: 1rem auto 0;
`;

const DeliveryDisclaimer: React.FC = () => {
  const { formatMessage } = useIntl();
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { deliveryDisclaimer, deliveryLogo } = featureDisclaimers || {};

  // The second condition is a afeguard against a Sanity bug with `localeString`
  // Refs. https://rbidigital.slack.com/archives/CCHFM51A8/p1620400033200600
  if (!deliveryDisclaimer || !deliveryDisclaimer.locale?.trim()) {
    return null;
  }

  return (
    <DeliveryDisclaimerContainer>
      {deliveryDisclaimer.locale}
      {deliveryLogo && (
        <DeliveryLogoContainer>
          <Picture
            image={deliveryLogo.locale}
            alt={formatMessage({ id: 'deliveryLogoAlt' })}
            objectFitContain
          />
        </DeliveryLogoContainer>
      )}
    </DeliveryDisclaimerContainer>
  );
};

export default DeliveryDisclaimer;
